import React, { useEffect } from 'react';
import styled, { useTheme } from 'styled-components';
import { ClickToCopyBlock } from '@monavate/ui-core';

const Title = styled.div`
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
`;

const ContentBlock = styled.div`
    font-family: Poppins;
    width: 100%;
`;

const ClickToCopyBlockWrap = styled.div`
    & > div {
        background: ${(props) => props.theme['Status/neutral/bg']};
    }
`;

const InfoBlock = styled.div`
    display: flex;
    gap: 8px;
    flex-direction: column;
    margin-top: 16px;
    background: ${(props) => props.theme['Surface/page']};
    border: 1px solid ${(props) => props.theme['Borders/quiet']};
    padding: 12px 16px;
`;

const InfoBlockTitle = styled.div`
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
`;

interface SimulateTransactionIdProps {
    transactionId: string;
}

const SimulateTransactionId: React.FC<SimulateTransactionIdProps> = ({ transactionId }) => {
    const theme = useTheme();
    useEffect(() => {
        console.log(theme);
    }, []);
    return (
        <>
            <ContentBlock>
                <Title>Transaction ID</Title>
                <ClickToCopyBlockWrap>
                    <ClickToCopyBlock
                        text={transactionId}
                        style={{ marginTop: '12px' }}
                        mode={theme?.mode}
                    />
                </ClickToCopyBlockWrap>
                <InfoBlock>
                    <InfoBlockTitle>We’ll show you this transaction ID just once</InfoBlockTitle>
                    <div>
                        This transaction ID will be required to make a clearing. Please, copy it.
                        <br />
                        Don’t worry, you can regenerate it if you lose this one.
                    </div>
                </InfoBlock>
            </ContentBlock>
        </>
    );
};

export default SimulateTransactionId;
